import React from 'react';
import { Layout, Tooltip } from 'antd';
import './IconFooter.scss';
import PrivacyPolicy from '../../Documents/Privacy-policy-6495244-edited 12 May 2021.pdf';
import poweredByHn from '../../images/poweredByHN.png';

const Footer = Layout.Footer;

export default function IconFooter() {
  return (
    <Footer className="nffs-icon-footer">
      <span className='nffs-icon-footer-links-container'>
        <span className="nffs-icon-footer-powered">
          <Tooltip placement="topRight" title='Powered By Horizon'>
            <a href="https://hil.us/" target='_blank' rel="noopener noreferrer"><img src={poweredByHn} alt='Powered By Horizon' /></a>
          </Tooltip>

        </span>
        <span className="nffs-icon-footer-links">
          <a href="/about">About ICON</a>
          <a href="/contact">Contact Us</a>
          <a href={PrivacyPolicy} target="_blank">
            Privacy Policy
          </a>
        </span>
      </span>

      <span>
        Use of the ICON portal requires{' '}
        <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">Google Chrome</a>,{' '}
        <a href="https://www.mozilla.org/en-US/firefox/" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a>{' '} or {' '}
        <a href="https://www.microsoft.com/en-us/windows/microsoft-edge" target="_blank" rel="noopener noreferrer">Microsoft Edge</a>{' '} with cookies and Javascript enabled.
      </span>
    </Footer>
  );
}



// WEBPACK FOOTER //
// ./src/components/IconFooter/IconFooter.jsx